<template>
  <div class="subpage main_area">
    <div class="layout position-relative settings">
      <div class="card_container mt-2">
        <div class="setting_items">
          <div>语言</div>
          <div>简体中文</div>
        </div>
      </div>
      <button class="btn btn_trans_red btn-block logout_btn active" @click="outLogin">登出</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'setting',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {
    outLogin() {
      let that = this;
      this.$dialog
        .confirm({
          title: '提示',
          message: '确定要退出登录吗？',
        })
        .then(() => {
          // on confirm
          that.$parent.showLoading();
          that.$apiFun
            .post('/api/logoff', {})
            .then(res => {
              that.$parent.clearUser();
              that.$parent.hideLoading();

              setTimeout(() => {
                that.$parent.goNav('/');
              }, 1000);
            })
            .catch(() => {
              that.$parent.clearUser();

              that.$parent.hideLoading();

              setTimeout(() => {
                that.$parent.goNav('/');
              }, 1000);
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.logout_btn {
  position: fixed;
  bottom: 105px;
  left: 0;
  right: 0;
  margin: auto;
  width: 66%;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/setting.vue